export const DB_NAME = "idea-structuring-agent-db";
export const SETTINGS_STORE_NAME = "settings";
